import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SubStepEnum } from '../models/sub-step.enum';
import { MaterialSubStepService } from '../services/material-sub-step.service';
import { MaterialsFacadeService } from '../services/materials.facade.service';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../../../services/modal.service';
import { PostType } from '../../../../../models/configurators-2d/applications/fence/post-type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Configuration } from '../../../../../models/configurators-2d/applications/fence/configuration';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { PostTypeStateService } from '../../services/post-type.state.service';

@Component({
  selector: 'ng-casto-materials-posts',
  templateUrl: './materials-posts.component.html',
  styleUrl: './materials-posts.component.scss',
})
export class MaterialsPostsComponent implements OnInit {
  /** Base URL de l'API */
  baseImgURL: string = undefined;

  /** Langue sélectionnée */
  currentLang: string;
  protected readonly SubStepEnum = SubStepEnum;
  private readonly materialSubStepService = inject(MaterialSubStepService);
  private readonly materialsFacadeService = inject(MaterialsFacadeService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly fenceService = inject(FenceService);
  private readonly translateService = inject(TranslateService);
  private readonly postTypeStateService = inject(PostTypeStateService);
  protected readonly modalService = inject(ModalService);

  constructor() {
    this.baseImgURL = this.fenceService.apiUrl;
  }

  /**
   * Retourne le message de déréférencement
   */
  protected get disableMessage(): string {
    return this.materialsFacadeService.disableMessage();
  }

  /**
   * Retourne la configuration actuelle
   */
  protected get configuration(): Configuration {
    return this.materialsFacadeService.configuration();
  }

  /**
   * Retourne la sous-étape courante du composant
   * @protected
   */
  protected get subStep(): SubStepEnum {
    return this.materialSubStepService.subStep();
  }

  /**
   * Retourne la liste des types de poteaux disponibles
   */
  protected get postTypes(): PostType[] {
    return this.postTypeStateService.postTypes();
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.getBrowserLang();
  }

  /**
   * Gère l'affichage/masquage des sous-menus en accordéon
   * @param step - Numéro du sous-menu (1: Lames, 2: Poteaux, 3: Lames décoratives, 4: Décors, 5: Panneaux, 6: Portillons)
   */
  protected toggleCollapse(step: SubStepEnum): void {
    this.materialSubStepService.toggleCollapse(step);
  }

  /**
   * Sélectionne un type de poteau et met à jour la configuration
   * @param postType - Le type de poteau sélectionné
   */
  protected selectPostType(postType: PostType): void {
    // pas de sélection si le poteau est désactivée
    if (postType.isDisabled) {
      return;
    }

    this.materialsFacadeService
      .selectPostType(postType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: err => logError('Erreur sélection postType:', err),
      });
  }

  /**
   * Vérifie si un type de poteau est actuellement sélectionné dans la configuration
   * @param postType - type de poteau
   * @returns true si le type de poteau est sélectionné, false sinon
   */
  protected isPostTypeSelected(postType: PostType): boolean {
    return this.materialsFacadeService.isPostTypeSelected(postType);
  }
}
